// NewFeature Component Image Data
// แยก URL รูปภาพเป็น desktop และ mobile versions

// Desktop Images Data
export const DESKTOP_NEW_FEATURE_DATA = {

  headerfirst: "https://gpfimg-cdn.azureedge.net/micrositemygpftwins/phase3/desktop/page5/Asset017.png",
  headersecond: "https://gpfimg-cdn.azureedge.net/micrositemygpftwins/phase3/desktop/page6/Asset019.png",
  headerthird: "https://gpfimg-cdn.azureedge.net/micrositemygpftwins/phase3/desktop/page7/Asset026.png",


  mainfirst: "https://gpfimg-cdn.azureedge.net/micrositemygpftwins/phase3/desktop/page5/Asset018.png",
  
  mainsecond: [
    "https://gpfimg-cdn.azureedge.net/micrositemygpftwins/phase3/desktop/page6/Asset020.png",
    "https://gpfimg-cdn.azureedge.net/micrositemygpftwins/phase3/desktop/page6/Asset021.png",
    "https://gpfimg-cdn.azureedge.net/micrositemygpftwins/phase3/desktop/page6/Asset022.png",
    "https://gpfimg-cdn.azureedge.net/micrositemygpftwins/phase3/desktop/page6/Asset023.png",
    "https://gpfimg-cdn.azureedge.net/micrositemygpftwins/phase3/desktop/page6/Asset024.png",
    "https://gpfimg-cdn.azureedge.net/micrositemygpftwins/phase3/desktop/page6/Asset025.png"
  ],
  
  mainthird: [
    "https://gpfimg-cdn.azureedge.net/micrositemygpftwins/phase3/desktop/page7/Asset027.png",
    "https://gpfimg-cdn.azureedge.net/micrositemygpftwins/phase3/desktop/page7/Asset028.png"
  ]
};

// Mobile Images Data
export const MOBILE_NEW_FEATURE_DATA = {

  headerfirst: "https://gpfimg-cdn.azureedge.net/micrositemygpftwins/phase3/mobile/page5/Asset017.png",
  headersecond: "https://gpfimg-cdn.azureedge.net/micrositemygpftwins/phase3/mobile/page6/Asset026.png",
  headerthird: "https://gpfimg-cdn.azureedge.net/micrositemygpftwins/phase3/mobile/page7/Asset034.png",


  mainfirst: [
    "https://gpfimg-cdn.azureedge.net/micrositemygpftwins/phase3/mobile/page5/Asset018.png",
    "https://gpfimg-cdn.azureedge.net/micrositemygpftwins/phase3/mobile/page5/Asset024.png",
    "https://gpfimg-cdn.azureedge.net/micrositemygpftwins/phase3/mobile/page5/Asset022.png",
    "https://gpfimg-cdn.azureedge.net/micrositemygpftwins/phase3/mobile/page5/Asset020.png",
    "https://gpfimg-cdn.azureedge.net/micrositemygpftwins/phase3/mobile/page5/Asset021.png"
  ],
  
  mainsecond: [
    "https://gpfimg-cdn.azureedge.net/micrositemygpftwins/phase3/mobile/page6/Asset027.png",
    "https://gpfimg-cdn.azureedge.net/micrositemygpftwins/phase3/mobile/page6/Asset028.png",
    "https://gpfimg-cdn.azureedge.net/micrositemygpftwins/phase3/mobile/page6/Asset029.png",
    "https://gpfimg-cdn.azureedge.net/micrositemygpftwins/phase3/mobile/page6/Asset030.png",
    "https://gpfimg-cdn.azureedge.net/micrositemygpftwins/phase3/mobile/page6/Asset031.png",
    "https://gpfimg-cdn.azureedge.net/micrositemygpftwins/phase3/mobile/page6/Asset032.png"
  ],
  
  mainthird: [
    "https://gpfimg-cdn.azureedge.net/micrositemygpftwins/phase3/mobile/page7/Asset033.png",
    "https://gpfimg-cdn.azureedge.net/micrositemygpftwins/phase3/mobile/page7/Asset041.png",
    "https://gpfimg-cdn.azureedge.net/micrositemygpftwins/phase3/mobile/page7/Asset035.png",
    "https://gpfimg-cdn.azureedge.net/micrositemygpftwins/phase3/mobile/page7/Asset036.png",
    "https://gpfimg-cdn.azureedge.net/micrositemygpftwins/phase3/mobile/page7/Asset037.png",
    "https://gpfimg-cdn.azureedge.net/micrositemygpftwins/phase3/mobile/page7/Asset038.png",
    "https://gpfimg-cdn.azureedge.net/micrositemygpftwins/phase3/mobile/page7/Asset039.png",
    "https://gpfimg-cdn.azureedge.net/micrositemygpftwins/phase3/mobile/page7/Asset040.png"
  ]
};

// Legacy export for backward compatibility
export const NEW_FEATURE_DATA = {
  DESKTOP: DESKTOP_NEW_FEATURE_DATA,
  MOBILE: MOBILE_NEW_FEATURE_DATA
};

